import { render, staticRenderFns } from "./schema.form.vue?vue&type=template&id=d0a2f070&scoped=true&"
import script from "./schema.form.vue?vue&type=script&lang=js&"
export * from "./schema.form.vue?vue&type=script&lang=js&"
import style0 from "./schema.form.vue?vue&type=style&index=0&id=d0a2f070&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a2f070",
  null
  
)

export default component.exports